/* eslint-disable func-names */
// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Form, Button, Row, Col, DatePicker as AntDatePicker } from 'antd';

// CUSTOM MODULES
import {
	fetchExtracReqByPatientID,
	fetchExtracReqByPatientName,
	fetchExtracReqByDate,
} from 'services/phlebo/specimenTracking';
import HttpCodeMessage from 'shared_components/message_http_status';
import { RegexInput } from 'shared_components/pattern_input';
import { showMessage } from 'services/settings/message';

// CSS
import './search_patient_form.css';
import { buttonNames } from 'shared_components/search_patient_form/settings';

// CONSTANTS
class SearchPatientHeaderForm extends React.Component {
	constructor(props) {
		super(props);

		this.formRef = React.createRef();
	}

	state = {
		patientID: '',
		patientName: '',
		requestDate: '',
		loading: false,
		selectedDateValue: moment().format('YYYYMMDD'),
	};

	handleInputChange = event => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	handleSubmit = async formValue => {
		const { patientID, patientName, requestDate } = formValue;
		const { populateExtractedPatients, populateForExtractionPatients } = this.props;

		const requestDateString =
			requestDate === null ? moment().format('YYYYMMDD') : requestDate.format('YYYYMMDD');
		const isByDate = !patientID && !patientName;
		const isByName = patientName && requestDate;
		const isById = patientID && requestDate;

		let patients = {};

		this.setState({ loading: true });

		if (isById) {
			patients = await fetchExtracReqByPatientID({ requestDate: requestDateString, patientID });
			console.log('search by patientID');
		}

		if (isByName) {
			patients = await fetchExtracReqByPatientName({ requestDate: requestDateString, patientName });
			console.log('search by patientName');
		}

		if (isByDate) {
			patients = await fetchExtracReqByDate({ requestDate: requestDateString });
			console.log('search by Date', patients);
		}

		this.setState({ loading: false });

		// Handle cases where patients might be false, empty array, or missing properties
		const extractedData = patients && patients.extracted ? patients.extracted : [];
		const forExtractionData = patients && patients.forExtraction ? patients.forExtraction : [];

		populateExtractedPatients(extractedData);
		populateForExtractionPatients(forExtractionData);

		// // Check if both arrays are empty
		// const isExtractedEmpty = extractedData.length === 0;
		// const isForExtractionEmpty = forExtractionData.length === 0;

		// if (isExtractedEmpty && isForExtractionEmpty) {
		// 	showMessage('M0001');
		// }
	};

	clearItems = async () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({
			patientID: '',
			patientName: '',
			requestDate: moment(),
		});

		this.props.clearPatients();
	};

	handleFocusID = () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ patientName: '' });
	};

	handleFocusName = () => {
		const { setFieldsValue } = this.formRef.current;

		//setFieldsValue({ patientID: '', requestDate: moment() });
		//remove resetting date on focus name field
		setFieldsValue({ patientID: '' });
	};

	refreshSearch = async () => {
		const { getFieldsValue } = this.formRef.current;
		const formValues = getFieldsValue();
		await this.handleSubmit(formValues);
	};


	render() {
		const { patientID, patientName, loading } = this.state;
		return (
			<Form
				className="phlebo-search-patient-form"
				onFinish={this.handleSubmit}
				ref={this.formRef}
				layout="vertical"
			>
				<div className="container">
					<Col className="search-date">
						<Form.Item
							required={true}
							label="REQUEST DATE"
							name="requestDate"
							initialValue={moment()}
						>
							<AntDatePicker
								allowClear={true}
								format={'MM-DD-YYYY'}
								style={{ width: '100%' }}
								placeholder=""
							/>
						</Form.Item>
					</Col>
					<Col style={{ textAlign: 'center', marginTop: 25 }}>|</Col>
					<Col className="search-id">
						<Form.Item label="PATIENT ID" name="patientID">
							<RegexInput
								value={patientID}
								onFocus={this.handleFocusID}
								maxLength={15}
								regex={/[a-zA-Z0-9 -]/}
							/>
						</Form.Item>
					</Col>
					<Col style={{ textAlign: 'center', marginTop: 24 }}>OR</Col>
					<Col className="search-name">
						<Form.Item label="PATIENT NAME" name="patientName">
							<RegexInput
								value={patientName}
								onChange={this.handleInputChange}
								onFocus={this.handleFocusName}
								placeholder="LASTNAME,FIRSTNAME"
								maxLength={100}
								regex={/[A-Za-z0-9, -]/}
							/>
						</Form.Item>
					</Col>

					<Col>
						<Form.Item shouldUpdate>
							{({ getFieldsValue }) => {
								const { requestDate } = getFieldsValue();

								return (
									<div className="buttons">
										<Button
											className="form-button"
											shape="round"
											style={{ width: 120 }}
											onClick={this.clearItems}
										>
											{buttonNames.clear}
										</Button>
										<Button
											shape="round"
											className="form-button"
											type="primary"
											htmlType="submit"
											disabled={!requestDate}
											loading={loading}
											style={{ width: 120 }}
										>
											{buttonNames.search}
										</Button>
									</div>
								);
							}}
						</Form.Item>
					</Col>
				</div>
			</Form>
		);
	}
}

SearchPatientHeaderForm.propTypes = {
	populateExtractedPatients: PropTypes.func.isRequired,
	populateForExtractionPatients: PropTypes.func.isRequired,
	clearPatients: PropTypes.func.isRequired,
};

export default SearchPatientHeaderForm;
